
class Equipment {
  constuctor() {}

  /**
   * Get all 
   */
  async all() {
    let res = await fetch(`/ajax/equipment`)
    let data = await res.json();
    return data
  }

  async find(ids) {
    // If string id, convert to single item array
    if (typeof ids === 'string') {
      ids = [ids]
    }

    let res = await fetch(`/ajax/equipment/id?ids=${ids}`)
    let data = await res.json();
    return data
  }

  async getByCategory(category) {
    let res = await fetch(`/ajax/equipment/category/${category}`)
    let data = await res.json();
    return data
  }

  async getByName(name) {
    let res = await fetch(`/ajax/equipment/name?name=${name}`)
    let data = await res.json();
    return data
  }

  async getByNames(names) {
    let res = await fetch(`/ajax/equipment/names?names=${names.join(',')}`)
    let data = await res.json();
    return data
  }
}

export default Equipment
